import React from "react";
import { statusCategories } from "../../../../Findings/FindingDetailsPane/FindingDetailsPaneHeader/Statuses/StatusUtils";
import PieChart from "../../PieChart";
import { SLA } from "../SLAUtils";
import type { SelectedScope } from "../../../../types/scope";

interface FixedFindingsProps {
  selectedScope?: SelectedScope | null;
  filterToExecute?: string | null;
  scopeToExecute?: string | null;
  id?: string;
  filtersFieldsToOverride?: string[];
  showIgnored?: boolean;
  setIsReadyToExport?: ((isReady: boolean) => void) | null;
}

const FixedFindings: React.FC<FixedFindingsProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  id,
  filtersFieldsToOverride = [],
  showIgnored = true,
  setIsReadyToExport,
}) => {
  const chartFilterValue = [
    {
      type: "category",
      key: statusCategories.IGNORED,
      id: statusCategories.IGNORED,
    },
    {
      type: "category",
      key: statusCategories.FIXED,
      id: statusCategories.FIXED,
    },
  ];

  const filtersConfig = {
    filtersjson: filterToExecute || null,
    scopesjson: scopeToExecute || null,
    scopesid: selectedScope?.value?.id,
    filters_fields_to_override: [
      JSON?.stringify({
        field: "remediation_item.actual_status",
        condition: "",
        value: {
          field: "category",
          condition: "in",
          value: [
            ...(showIgnored ? [statusCategories.IGNORED] : []),
            statusCategories.FIXED,
          ],
        },
      }),
      ...filtersFieldsToOverride,
    ],
  };

  const skip =
    (!scopeToExecute && !selectedScope?.value?.id) || !filterToExecute;

  const chartName = `slaFixedFindingsDiv-${id}`;

  return (
    <PieChart
      categories={SLA}
      skip={skip}
      groupBy={["finding.sla_status"]}
      filtersConfig={filtersConfig}
      legendTitle={"SLA Status"}
      chartName={chartName}
      chartFilterValue={chartFilterValue}
      actualFilterField={"remediation_item.sla_status"}
      dataSubject={"Findings"}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default FixedFindings;
